import { useAxiosWrapper } from '../../services/axiosWrapper';

export interface INoticiasFilter {
    pagina?: number;
    tamanhoPagina?: number;
}

export function useNoticiaActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/v1/noticias`;
    const axiosWrapper = useAxiosWrapper();

    return {
        filter: filter
    };

    async function filter(filterParams: INoticiasFilter) {
        const queryParams = new URLSearchParams();

        if (filterParams.pagina) queryParams.append('pagina', filterParams.pagina.toString());
        if (filterParams.tamanhoPagina)
            queryParams.append('tamanhoPagina', filterParams.tamanhoPagina.toString());

        const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
        return await axiosWrapper.get(`${baseUrl}${queryString}`);
    }
}
